import { merge, SearchBox, Stack, StackItem, Text } from '@fluentui/react';
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ResponsiveSize, useResponsiveSize } from '../contexts/responsiveContext';

const Page = (props) => {

    const {
        children,
        onSearch = undefined,
        searchedValue = "",
        title = ""
    } = props;

    const { responsiveSize } = useResponsiveSize();
    const location = useLocation();

    const styles = useMemo(
        () => {
            let styles = {
                backgroundOffset: {
                    // Permet un alignement des lignes verticales de l'arri�re plan avec children
                    // Sans quoi le white background masque ces lignes
                    root: {
                        //background: "white", // KP - 14/11/2023 : afficher les lignes verticales (enlever le fond blanc ; demande de la com')
                        height: "100%",
                        //marginLeft: 1,
                        //marginRight: 1,
                    }
                },
                header: {
                    root: {
                        flexDirection: responsiveSize === ResponsiveSize.small ? "column" : "row",
                        gap: 13,
                        justifyContent: "space-between",
                    }
                },
                inner: {
                    root: {
                        height: "100%",
                        //marginLeft: -1,
                        //marginRight: -1,
                        paddingBottom: responsiveSize === ResponsiveSize.small && location.pathname === "/messages" ? "unset" : 26, // Messagerie : pas de paddingBottom pour coller la saisie aux bords de l'�cran
                        paddingTop: 18,
                    }
                },
                searchbox: {
                    field: {
                        marginBottom: -4,
                        selectors: { "::placeholder": { color: "#878787" } }
                    },
                    root: {
                        color: "red",
                        background: "#FAFAFA",
                        border: "1px solid rgba(0, 0, 0, 0.07)",
                        flexDirection: "row-reverse",
                        width: 289
                    }
                },
                title: {
                    root: {
                        color: "black",
                        fontFamily: "Kepler Std",
                        fontSize: 23,
                        fontWeight: 700,
                        lineHeight: "28px",
                        zIndex: 1,
                    }
                }
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        inner: { root: { paddingTop: 26 } },
                        searchbox: { root: { width: 240 } },
                        title: {
                            root: {
                                fontSize: 30,
                                lineHeight: "36px"
                            }
                        }
                    }
                );

            return styles;
        },
        [location, responsiveSize]
    );

    return <Stack verticalFill>
        <Stack styles={styles.header}>
            {!!title && <Text styles={styles.title}>{title}</Text>}
            {typeof onSearch === "function" &&
                <SearchBox
                    onChange={(event, newValue) => onSearch(newValue)}
                    onClear={event => onSearch(undefined)}
                    onSearch={onSearch}
                    placeholder="Recherche"
                    styles={styles.searchbox}
                    value={searchedValue}
                />
            }
        </Stack>
        <StackItem styles={styles.backgroundOffset}>
            <Stack styles={styles.inner}>{children}</Stack>
        </StackItem>
    </Stack>;

};

export default Page;